import React from "react";
import TextInput from "../../../components/elements/forms/TextInput";
// import SubmitButton from "../../../components/elements/forms/SubmitButton";
import { useNavigate } from "react-router-dom";
import {
  useOrganizationData,
  updateAdmin,
} from "../../../services/api/settings";
import { AdminEdit } from "../../../store/types/settings";
import { useAppDispatch } from "../../../store/hooks";
import OnboardingGuide from "../../../components/elements/OnboardingGuide";
import { Settings as SettingsIcon } from "lucide-react";

const Profile: React.FC = () => {
  const navigate = useNavigate();
  const { organizationData } = useOrganizationData();
  const [data, dataSet] = React.useState<AdminEdit>({
    name: "",
    representativeName: "",
    representativeFirstName: "",
    representativeLastName: "",
    representativeEmail: "",
    representativeRole: "",
    referralSource: "",
    contactEmail: "",
    contactPhone: "",
    address: "",
    registrationNo: "",
    admins: [],
  });

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    // errorSet((prev) => ({ ...prev, [name]: "" }));
  };
  const [loading, setLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const [showOnboarding, setShowOnboarding] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState("profile");

  // Helper function to get admin ID from localStorage
  const getAdminIdFromStorage = (): string | null => {
    try {
      const loginData = localStorage.getItem("loginData");
      if (loginData) {
        const parsedData = JSON.parse(loginData);
        return parsedData.data?.admin?.id || null;
      }
      return null;
    } catch (err) {
      console.error("Error parsing loginData from localStorage:", err);
      return null;
    }
  };

  const onSubmitHandler = async () => {
    const adminId = getAdminIdFromStorage();

    if (!adminId) {
      console.error("Admin ID not found in localStorage");
      return;
    }

    setLoading(true);
    try {
      await updateAdmin(dispatch, adminId, data);
      // window.location.reload();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleOnboarding = () => {
    localStorage.removeItem("onboarding_completed");
    setShowOnboarding(true);
  };

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
  };

  return (
    <div className="w-full">
      <div className="max-w-[1096px] mx-auto px-3">
        <div className="flex border-b border-border text-20 pt-3">
          <div
            onClick={() => navigate(`/settings/profile`)}
            className="border-b-[3px] border-secondary pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[400]">Profile</p>
          </div>
          <div
            onClick={() => navigate(`/settings/admin/create`)}
            className={`pb-1 cursor-pointer md:mr-8 mr-5`}
          >
            <p className="font-[400]">Create Admin</p>
          </div>
          <div
            onClick={() => navigate(`/settings/admin`)}
            className="pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[400]">Admins</p>
          </div>
          <div
            onClick={() => {
              navigate(`/settings/change-password`);
              setActiveTab("password");
            }}
            className={`pb-1 cursor-pointer md:mr-8 mr-5 ${
              activeTab === "password" ? "border-b-[3px] border-secondary" : ""
            }`}
          >
            <p className="font-[400]">Change Password</p>
          </div>
          <div
            onClick={() => setActiveTab("onboarding")}
            className={`pb-1 cursor-pointer ${
              activeTab === "onboarding"
                ? "border-b-[3px] border-secondary"
                : ""
            }`}
          >
            <p className="font-[400]">Settings</p>
          </div>
        </div>
        <div className="rounded-10 bg-white px-4 py-4 w-[100%] mt-5">
          <div className="grid grid-cols-2 gap-3">
            <TextInput
              label="Business Name"
              placeholder="Business"
              name="name"
              // status={dataErr.name}
              value={data.name || organizationData?.name}
              onChange={onChangeHandler}
            />
            <TextInput
              label="Email"
              placeholder="johndoe@email.com"
              name="contactEmail"
              // status={dataErr.email}
              value={data.contactEmail || organizationData?.contactEmail}
              onChange={onChangeHandler}
              // onBlur={onCheckEmail}
              readOnly={true}
              className="cursor-wait"
            />
            <TextInput
              label="First Name"
              placeholder="John"
              name="firstName"
              // status={dataErr.firstName}
              value={
                data.representativeFirstName ||
                organizationData?.representativeFirstName
              }
              onChange={onChangeHandler}
            />
            {/* {organizationData?.admins?.[0] && ( */}
            <TextInput
              // key={organizationData.admins[0].id}
              label="Last Name"
              placeholder="Doe"
              name="lastName"
              // status={dataErr.lastName}
              value={
                data.representativeLastName ||
                organizationData?.representativeLastName
              }
              onChange={onChangeHandler}
            />
            {/* )} */}
            <TextInput
              label="Phone Number"
              placeholder="John"
              name="contactPhone"
              // status={dataErr.contactPhone}
              value={data.contactPhone || organizationData?.contactPhone}
              onChange={onChangeHandler}
            />
            <TextInput
              label="Office Address"
              placeholder="Address"
              name="address"
              // status={dataErr.address}
              value={data.address || organizationData?.address}
              onChange={onChangeHandler}
            />
            <TextInput
              label="CAC Reg. Number"
              placeholder="Reg Number"
              name="registrationNo"
              // status={dataErr.registrationNo}
              // value={data.registrationNo}
              onChange={onChangeHandler}
            />
            <TextInput
              label="Subscription Plan"
              placeholder="Professional"
              name="subsciptionTier"
              // status={dataErr.subscriptionTier}
              value={organizationData?.subscriptionTier
                ?.replace(/_+/g, " ")
                .toLowerCase()
                ?.replace(/\b\w/g, (char) => char.toUpperCase())}
              onChange={onChangeHandler}
              readOnly={true}
            />
          </div>
          <div className="flex items-center max-w-[350px] mx-auto gap-2 mt-4">
            {/* <UnsubscribeButton /> */}
            {/* <div className="min-w-[140px]">
            <SubmitButton
              title="Update Profile"
              onSubmitHandler={onSubmitHandler}
              loading={loading}
              className={`font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary`}
            />
            </div> */}
          </div>
        </div>

        {/* Onboarding Settings Tab */}
        {activeTab === "onboarding" && (
          <div className="rounded-10 bg-white px-6 py-6 w-full mt-5">
            <OnboardingGuide
              run={showOnboarding}
              manualTrigger={showOnboarding}
              onComplete={handleOnboardingComplete}
            />

            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Application Settings
            </h2>

            <div className="space-y-4">
              {/* Onboarding Guide Toggle */}
              <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
                <div className="flex-1">
                  <h3 className="text-base font-medium text-gray-900 mb-1">
                    Show Onboarding Guide
                  </h3>
                  <p className="text-sm text-gray-600">
                    Restart the interactive walkthrough to learn about AI
                    Recruiter features
                  </p>
                </div>

                <button
                  onClick={handleToggleOnboarding}
                  className="ml-4 px-4 py-2 bg-[#243677] text-white rounded-lg font-medium text-sm hover:bg-[#1e2a5e] transition-colors flex items-center gap-2"
                >
                  <SettingsIcon className="w-4 h-4" />
                  Start Tour
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
